module.exports = __webpack_public_path__ + "img/m_pass_card.c85a8d18.png";